<template>
  <div class="container" id="nosotros">
    <div class="section infographic-section">
      <!-- Infografía 1: Tecnologías -->
      <div class="card-panel infographic-card" id="tecnologias">
        <h2 class="infographic-title text-shadow"><a href="/tecnologias">Tecnologías</a><br /><img alt="Tecnologías" src="@/assets/img/tecnologias.jpg" class="responsive-img" /></h2>
        <div class="row center-align row-flex">
          <div class="col s12 m6 l3 info-item">
            <div class="icon-container"><i class="material-icons">storage</i></div>
            <h4 class="item-title"><a href="/bases-de-datos">Bases de Datos</a></h4>
            <p class="item-text">Gestión y optimización de datos.</p>
          </div>
          <div class="col s12 m6 l3 info-item">
            <div class="icon-container"><i class="material-icons">code</i></div>
            <h4 class="item-title"><a href="/desarrollo">Desarrollo</a></h4>
            <p class="item-text">Software a medida para tus necesidades.</p>
          </div>
          <div class="col s12 m6 l3 info-item">
            <div class="icon-container"><i class="material-icons">layers</i></div>
            <h4 class="item-title"><a href="/plataformas">Plataformas</a></h4>
            <p class="item-text">Sistemas operativos y cloud.</p>
          </div>
          <div class="col s12 m6 l3 info-item">
            <div class="icon-container"><i class="material-icons">dns</i></div>
            <h4 class="item-title"><a href="/servidores">Servidores</a></h4>
            <p class="item-text">Infraestructura robusta y escalable.</p>
          </div>
        </div>
      </div>
      <!-- Infografía 2: Productos -->
      <div class="card-panel infographic-card" id="productos">
        <h2 class="infographic-title text-shadow"><a href="/productos">Ecosistema de Productos Digitales</a><br /><img alt="Productos" src="@/assets/img/products.jpg" class="responsive-img" /></h2>
        <div class="row center-align row-flex">
          <div class="col s12 m4 l4 info-item">
            <div class="icon-container"><i class="material-icons">business_center</i></div>
            <h4 class="item-title"><a href="/erp-sistema-de-administracion-de-recursos-empresariales">ERP</a></h4>
            <p class="item-text">Gestión integral de recursos.</p>
          </div>
          <div class="col s12 m4 l4 info-item">
            <div class="icon-container"><i class="material-icons">group</i></div>
            <h4 class="item-title"><a href="/crm-sistema-de-administracion-de-relaciones-con-clientes">CRM</a></h4>
            <p class="item-text">Relaciones con clientes.</p>
          </div>
          <div class="col s12 m4 l4 info-item">
            <div class="icon-container"><i class="material-icons">shopping_cart</i></div>
            <h4 class="item-title"><a href="/e-commerce-sistema-de-comercio-electronico">e-Commerce</a></h4>
            <p class="item-text">Comercio electrónico.</p>
          </div>
          <div class="col s12 m4 l4 info-item">
            <div class="icon-container"><i class="material-icons">web</i></div>
            <h4 class="item-title"><a href="/cms-sistema-de-administracion-de-contenido">CMS</a></h4>
            <p class="item-text">Contenido web dinámico.</p>
          </div>
          <div class="col s12 m4 l4 info-item">
            <div class="icon-container"><i class="material-icons">school</i></div>
            <h4 class="item-title"><a href="/lcms-sistema-de-gestion-de-contenido-para-el-aprendizaje">LCMS</a></h4>
            <p class="item-text">Aprendizaje digital.</p>
          </div>
          <div class="col s12 m4 l4 info-item">
            <div class="icon-container"><i class="material-icons">analytics</i></div>
            <h4 class="item-title"><a href="/big-data">Big Data</a></h4>
            <p class="item-text">Decisiones inteligentes.</p>
          </div>
        </div>
      </div>
      <!-- Infografía 3: Servicios -->
      <div class="card-panel infographic-card" id="servicios">
        <h2 class="infographic-title text-shadow"><a href="/servicios">Portafolio de Servicios</a><br /><img alt="Servicios" src="@/assets/img/services.jpg" class="responsive-img" /></h2>
        <div class="row center-align row-flex">
          <div class="col s12"><h5 class="subsection-title">Estrategia y Desarrollo</h5></div>
          <div class="col s12 m6 l3 info-item">
            <div class="icon-container"><i class="material-icons">assignment</i></div>
            <h3 class="item-title"><a href="/project-management-gestion-de-proyectos">Project Management</a> y <a href="/arquitectura-sistemas">Arquitectura de Sistemas</a></h3>
            <p class="item-text">Aseguro la entrega exitosa y puntual de tus iniciativas.</p>
          </div>
          <div class="col s12 m6 l3 info-item">
            <div class="icon-container"><i class="material-icons">science</i></div>
            <h3 class="item-title"><a href="/investigacion-desarrollo-e-innovacion-de-nuevas-tecnologias">I+D+i</a></h3>
            <p class="item-text">Aplico tecnologías emergentes para darte una ventaja competitiva.</p>
          </div>
          <div class="col s12 m6 l3 info-item">
            <div class="icon-container"><i class="material-icons">code</i></div>
            <h3 class="item-title"><a href="/desarrollo-de-sistemas">Desarrollo de Sistemas</a></h3>
            <p class="item-text">Creo software a medida que automatiza y optimiza tus procesos.</p>
          </div>
          <div class="col s12 m6 l3 info-item">
            <div class="icon-container"><i class="material-icons">web</i></div>
            <h3 class="item-title"><a href="/desarrollo-web">Desarrollo Web</a></h3>
            <p class="item-text">Construyo sitios y aplicaciones web que cautivan a tus usuarios.</p>
          </div>

          <div class="col s12"><h5 class="subsection-title">Infraestructura y Cloud</h5></div>
          <div class="col s12 m6 l3 info-item">
            <div class="icon-container"><i class="material-icons">dns</i></div>
            <h3 class="item-title"><a href="/centro-de-datos-hosting-cloud">Centro de Datos,Hosting y Cloud</a></h3>
            <p class="item-text">Implemento la base sólida, segura y escalable para tu operación.</p>
          </div>
          <div class="col s12 m6 l3 info-item">
            <div class="icon-container"><i class="material-icons">layers</i></div>
            <h3 class="item-title"><a href="/virtualizacion">Virtualización</a></h3>
            <p class="item-text">Maximizo la eficiencia de tu hardware y reduzco costos operativos.</p>
          </div>
          <div class="col s12 m6 l3 info-item">
            <div class="icon-container"><i class="material-icons">cloud_circle</i></div>
            <h3 class="item-title"><a href="/iaas-infraestructura-como-servicio">IaaS</a>, <a href="/paas-plataforma-como-servicio">PaaS</a> y <a href="/saas-software-como-servicio">SaaS</a></h3>
            <p class="item-text">Te ayudo a elegir y gestionar el modelo de nube perfecto para ti.</p>
          </div>
          <div class="col s12 m6 l3 info-item">
            <div class="icon-container"><i class="material-icons">email</i></div>
            <h3 class="item-title"><a href="/correo-electronico">Correo Electrónico</a></h3>
            <p class="item-text">Garantizo una comunicación profesional, segura y siempre disponible.</p>
          </div>

          <div class="col s12"><h5 class="subsection-title">Marketing y Presencia Digital</h5></div>
          <div class="col s12 m6 l3 info-item">
            <div class="icon-container"><i class="material-icons">trending_up</i></div>
            <h3 class="item-title"><a href="/seo-optimizacion-para-motores-de-busqueda">SEO</a> y <a href="/sem-mercadotecnia-para-motores-de-busqueda">SEM</a></h3>
            <p class="item-text">Aumento tu visibilidad en buscadores para atraer tráfico de calidad.</p>
          </div>
          <div class="col s12 m6 l3 info-item">
            <div class="icon-container"><i class="material-icons">group</i></div>
            <h3 class="item-title">
              <a href="/smm-mercadotecnia-en-redes-sociales">SMM</a>, <a href="/smo-optimizacion-para-redes-sociales">SMO</a> y
              <a href="/community-manager-gestion-de-la-comunidad-online">Gestión de Redes</a>
            </h3>
            <p class="item-text">Construyo y gestiono una comunidad leal alrededor de tu marca.</p>
          </div>
          <div class="col s12 m6 l3 info-item">
            <div class="icon-container"><i class="material-icons">forward_to_inbox</i></div>
            <h3 class="item-title"><a href="/email-marketing-mercadotecnia-en-correos-electronicos">Email Marketing</a></h3>
            <p class="item-text">Fidelizo a tus clientes con campañas de comunicación directa y efectiva.</p>
          </div>
          <div class="col s12 m6 l3 info-item">
            <div class="icon-container"><i class="material-icons">insights</i></div>
            <h3 class="item-title"><a href="/e-marketing-mercadotecnia-online">e-Marketing</a></h3>
            <p class="item-text">Diseño una estrategia integral para atraer, convertir y retener clientes.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
